import { getSign } from "@/api/account";

export default async (appkey, appId) => { 
  const r = await getSign({
    url: location.href.split("#")[0],
    appkey,
    wx_app_id: appId
  });
  const { timestamp, signature, noncestr } = r.content;
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: noncestr, // 必填，生成签名的随机串
    signature: signature, // 必填，签名
    jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
  });
};
